require.config({
    baseUrl: '/js',
    packages: [
        {
            name: 'underscore',
            location: '../components/lodash'
        }
    ],
    paths: {
        'common': '../components/casumo-common/src/js',
        'requireLib': '../components/requirejs/require',
        'text': '../components/requirejs-text/text',
        'json': '../components/requirejs-plugins/src/json',
        'UAParser': '../components/ua-parser-js/src/ua-parser',

        'container': '../components/container/src',

        'durandal': '../components/Durandal/src/durandal/js',
        'plugins': '../components/Durandal/src/plugins/js',

        'bluebird': '../components/bluebird/js/browser/bluebird',

        'jquery': '../components/jquery/jquery.min',
        'jquery.easing': '../components/casumo-common/src/js/3rdparty/jquery.easing.1.3',
        'jquery.swipe': '../components/casumo-common/src/js/3rdparty/swipe-2.0.custom',
        'jquery.lazy': '../components/casumo-common/src/js/3rdparty/jquery.lazy-0.1.6',
        'jquery.cookie': '../components/casumo-common/src/js/3rdparty/jquery.cookie',
        'jquery.zelect': '../components/zelect/zelect',
        'iosslider': '../components/iosslider/_src/jquery.iosslider',
        'jquery.payment': '../components/jquery.payment/lib/jquery.payment',

        'jquery/cometd': '../components/casumo-common/src/js/3rdparty/org/cometd/jquery.cometd.dev-3.0.4',
        'org/cometd': '../components/casumo-common/src/js/3rdparty/org/cometd/cometd.dev-3.0.4',

        'knockout': '../components/knockout/dist/knockout',
        'knockout.punches': '../components/knockout.punches/knockout.punches',

        'underscore.string': '../components/casumo-common/src/js/3rdparty/underscore.string.min-2.3.0',

        'moment': '../components/casumo-common/src/js/3rdparty/moment.min-2.8.2',

        'accounting': '../components/casumo-common/src/js/3rdparty/accounting.min-0.3.2',
        'base64': '../components/casumo-common/src/js/3rdparty/base64',
        'regexp': '../components/casumo-common/src/js/regexp',
        'Modernizr':'../components/casumo-common/src/js/3rdparty/modernizr-2.6.2-transitions+transform',
        'Fingerprint': '../components/casumo-common/src/js/3rdparty/fingerprint.dev-0.5.2',
        'FingerprintV2': '../components/fingerprintjs2/fingerprint2',
        'showdown': '../components/showdown/src/showdown',
        'showdownTable': '../components/showdown/src/extensions/table',
        'fastclick':'../components/fastclick/lib/fastclick',
        'storejs': '../components/store.js/store',
        'sha1': '../components/SHA-1/sha1',
        'jsencrypt': '../components/jsencrypt/bin/jsencrypt',
        'uuid': '../components/node-uuid/uuid',
        'fontfaceobserver': '../components/fontfaceobserver/fontfaceobserver',

        'transitionMappings': '../components/casumo-common/src/js/transitionMappings', // mapping this path so that sites can easily redefine this module if needed as they may have different transitions
        'routes': '../components/casumo-common/src/js/routes', // should be overidden by each site

        'netent': 'https://casumo-static-test.casinomodule.com/gameinclusion/library/gameinclusion',
        'microgaming': (this.p || 'https://mobile3.gameassists.co.uk') + '/MobileWebGames/js/InterfaceApi/InterfaceApi'
    },

    map: {
        '*': {
            'knockout': 'ko/customisedKnockout',
            'underscore': 'common/customiseUnderscore',
            'moment': 'common/customiseMoment'
        },
        'knockout': { 'knockout': 'knockout' },
        'knockout.punches': { 'knockout': 'knockout' },
        'common/ko': { 'knockout': 'knockout' },
        'common/tools': { 'knockout': 'knockout' },
        'common/customiseKnockout': { 'knockout': 'knockout' },
        'container': { 'knockout': 'knockout' },
        'ko': { 'knockout': 'common/customiseKnockout' },
        'core/Form': { 'knockout': 'common/customiseKnockout' },
        'common/customiseUnderscore': { 'underscore': 'underscore' },
        'underscore': { 'underscore': 'underscore' },
        'common/customiseMoment': { 'moment': 'moment' },
        'moment': { 'moment': 'moment' }
    },

    deps: [
        'common/ko/customBinding/command',
        'common/ko/customBinding/dispatch',
        'common/ko/customBinding/markdown',
        'common/durandal/widgets/commonClock/viewmodel', 'text!common/durandal/widgets/commonClock/view.html',
        'common/config/momentLocales',

        // environment patches
        'common/patches/fixMobileScrolling',
        'common/polyfills'
    ],

    callback: function() {},

    shim: {
        'knockout': ['jquery'],
        'jquery.easing': ['jquery'],
        'jquery.lazy': ['jquery'],
        'iosslider': ['jquery'],
        'jquery/cometd': ['jquery', 'org/cometd', 'jquery.cookie'],
        'jquery.swipe':{
            exports:'Swipe'
        },
        'jquery.payment': ['jquery'],

        'Modernizr':{
            exports:'Modernizr'
        },
        'showdownTable': {
            deps: ['showdown']
        },
        'jsencrypt': {
            exports: 'JSEncrypt'
        },
        'fontfaceobserver': {
            exports: 'FontFaceObserver'
        },
        'netent': {
            exports: 'netent'
        },
        'microgaming': {
            exports: 'mgs'
        }
    }
});

define("require.config.js", function(){});

